import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface ActionTargetFormSlice {
  methNr?: number | string | null;
  grupNr?: number | string | null;
  heredar?: boolean;
}

/** Prueba no seleccionada (null/''); MethNr 0 del catálogo sí cuenta como selección. */
export function hasFilledMethNrValue(value: unknown): boolean {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const n = Number(value);
  return Number.isFinite(n);
}

/** Perfil no seleccionado; GrupNr 0 es un valor válido (#547). */
export function hasFilledGrupNrValue(value: unknown): boolean {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const n = Number(value);
  return Number.isFinite(n);
}

export function countActionTargetSelections(formValue: ActionTargetFormSlice): number {
  let count = 0;
  if (formValue.heredar === true) {
    count += 1;
  }
  if (hasFilledMethNrValue(formValue.methNr)) {
    count += 1;
  }
  if (hasFilledGrupNrValue(formValue.grupNr)) {
    count += 1;
  }
  return count;
}

export function isActionTargetBlockActive(showMethNr: boolean, showGrupNr: boolean): boolean {
  return showMethNr && showGrupNr;
}

export function actionTargetBlockValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formValue = control.value as ActionTargetFormSlice;
    const count = countActionTargetSelections(formValue);
    if (count === 0) {
      return { actionTargetRequired: true };
    }
    if (count > 1) {
      return { actionTargetExclusive: true };
    }
    return null;
  };
}

export function resolveActionMethNrForSave(formValue: ActionTargetFormSlice): number | null {
  if (formValue.heredar === true) {
    return -1;
  }
  if (hasFilledMethNrValue(formValue.methNr)) {
    return Math.trunc(Number(formValue.methNr));
  }
  if (hasFilledGrupNrValue(formValue.grupNr)) {
    return 0;
  }
  return null;
}

export function inferHeredarFromLoadedMethNr(methNr: number | string | null | undefined): boolean {
  return methNr === -1 || methNr === '-1';
}

export function shouldUseProfileOnlyFromLoaded(
  methNr: number | string | null | undefined,
  grupNr: number | string | null | undefined
): boolean {
  if (!hasFilledGrupNrValue(grupNr)) {
    return false;
  }
  if (inferHeredarFromLoadedMethNr(methNr)) {
    return false;
  }
  // En BD, perfil sin prueba explícita suele persistir MethNr=0.
  if (methNr === 0 || methNr === '0') {
    return true;
  }
  return !hasFilledMethNrValue(methNr);
}
